import {
  gtmPushAddToCart,
  gtmPushRemoveFromCart,
} from 'modules/gtm/modules/sections/cart/cart';
import { CustomDataType } from 'modules/gtm/modules/types';
import { parseCartItemToGTMProduct } from 'modules/gtm/utils/parsers';
import { CartItem } from 'commerce/scayle/user-interaction/types';
import { ClientPageType } from 'src/app/types';

export const GTMCart = {
  addProduct: (
    item: CartItem,
    currency = '',
    pageType?: ClientPageType,
    customData?: CustomDataType,
  ) =>
    gtmPushAddToCart(
      parseCartItemToGTMProduct(item, customData),
      currency,
      pageType,
    ),
  removeProduct: (
    item: CartItem,
    currency = '',
    pageType?: ClientPageType,
    customData?: CustomDataType,
  ) =>
    gtmPushRemoveFromCart(
      parseCartItemToGTMProduct(item, customData),
      currency,
      pageType,
    ),
  decrementProduct: (
    item: CartItem,
    currency = '',
    quantity: number,
    pageType?: ClientPageType,
  ) =>
    GTMCart.removeProduct(item, currency, pageType, {
      price: item.price.unit.withTax,
      quantity,
    }),
  incrementProduct: (
    item: CartItem,
    currency = '',
    quantity: number,
    pageType?: ClientPageType,
  ) =>
    GTMCart.addProduct(item, currency, pageType, {
      price: item.price.unit.withTax,
      quantity,
    }),
};
